import APIService from "./APIService";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { useTranslation } from "react-i18next";
import i18n from "i18next";

import ServiceClassPicker from "./ServiceClassPicker";
import TimberMaterialPicker from "./TimberMaterialPicker";
import ScrewPicker from "./ScrewPicker";
import CodePicker from "./CodePicker";
import PlatePicker from "./PlatePicker";

export default function StaffaT(props) {

  const ServiceClassRef = useRef(null);
  const TimberMaterialRef = useRef(null);
  const TimberMaterialSecRef = useRef(null);
  const CodeRef = useRef(null);
  const ScrewPickerRef = useRef(null);
  const PlatePickerRef = useRef(null);
  const [LoadDuration, SetLoadDuration] = useState("1");
  const [isKmodDisabled, setKmodDisabled] = useState(true);
  const [CreateReport, SetCreateReport] = useState("");
  const [Image, setImage] = useState("StaffaT/StaffaT_5.png");
  const [Ratio, setRatio] = useState("");
  const [validData, setValidData] = useState(true);
  const [resultMessages, setResultMessages] = useState("");
  const [plateValue, setPlateValue] = useState(4);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues: { HookUseEta: false } });

  const getRatio = () => {
    const Fvd = parseFloat(getValues("HookFvd"));
    const primaryB = parseFloat(getValues("HookMainB"));
    const primaryH = parseFloat(getValues("HookMainH"));
    const primaryElementType = 1;
    const secondaryBeamB = parseFloat(getValues("HookSecB"));
    const secondaryBeamH = parseFloat(getValues("HookSecH"));
    const totalX = 1;
    const totalY = parseInt(getValues("HookNy"));
    const stepY = parseFloat(getValues("HookStepY"));
    const SecondaryBeamAngle = parseFloat(getValues("HookAngle"));
    const offsetY = parseFloat(getValues("HookBsup"));
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const useEta = getValues("HookUseEta") ? 1 : 0;
    const predrill = getValues("Hookpredrill") ? 1 : 0;
    const language = i18n.language;
    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    var PrimaryElementMaterial = parseInt(TimberMaterialRef.current.getData());
    var SecondaryBeamMaterial = parseInt(TimberMaterialSecRef.current.getData());
    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    var TPlateType = parseInt(PlatePickerRef.current.getData());
    var code = parseInt(CodeRef.current.getData());
    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_TPLATE_RATIO;

    const promiseResult = APIService.GetRatio(
      {
        ServiceClass,
        LoadDuration,
        Fvd,
        primaryB,
        primaryH,
        primaryElementType,
        secondaryBeamB,
        secondaryBeamH,
        totalX,
        totalY,
        stepY,
        ScrewType,
        PrimaryElementMaterial,
        SecondaryBeamMaterial,
        TPlateType,
        predrill,
        CreateReport,
        useEta,
        language,
        kmod,
        email,
        SecondaryBeamAngle,
        code,
        offsetY,
      },
      address
    );
    promiseResult.then((value) => {
      console.log(value);
      setRatio(value["ratio"]);
      setResultMessages(value["result"]);
      setValidData(value["valid"]);
    });
  };

  const getReport = () => {
    const Fvd = parseFloat(getValues("HookFvd"));
    const primaryB = parseFloat(getValues("HookMainB"));
    const primaryH = parseFloat(getValues("HookMainH"));
    const primaryElementType = 1;
    const secondaryBeamB = parseFloat(getValues("HookSecB"));
    const secondaryBeamH = parseFloat(getValues("HookSecH"));
    const totalX = 1;
    const totalY = parseInt(getValues("HookNy"));
    const stepY = parseFloat(getValues("HookStepY"));
    const offsetY = parseFloat(getValues("HookBsup"));
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const useEta = getValues("HookUseEta") ? 1 : 0;
    const predrill = getValues("Hookpredrill") ? 1 : 0;
    const language = i18n.language;
    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    var PrimaryElementMaterial = parseInt(TimberMaterialRef.current.getData());
    var SecondaryBeamMaterial = parseInt(TimberMaterialSecRef.current.getData());
    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    var TPlateType = parseInt(PlatePickerRef.current.getData());
    const SecondaryBeamAngle = parseFloat(getValues("HookAngle"));
    var code = parseInt(CodeRef.current.getData());

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_TPLATE_REPORT;

    const promiseResult = APIService.GetReportComplete(
      {
        ServiceClass,
        LoadDuration,
        Fvd,
        primaryB,
        primaryH,
        primaryElementType,
        secondaryBeamB,
        secondaryBeamH,
        totalX,
        totalY,
        stepY,
        ScrewType,
        PrimaryElementMaterial,
        SecondaryBeamMaterial,
        TPlateType,
        predrill,
        CreateReport,
        useEta,
        language,
        kmod,
        email,
        SecondaryBeamAngle,
        code,
        offsetY,
      },
      address
    );
    promiseResult.then((response) => console.log("downloaded")).catch((error) => console.log("error", error));
    setRatio("");
    setResultMessages("");
    setValidData("");
  };

  function updateImage(plateId) {
    var angleVal = getValues("HookAngle");
    if (angleVal) {
      var angle = parseFloat(angleVal);
      if (angle !== 90.0) {
        if (plateId < 6){
          setImage("StaffaT/StaffaT_1.png");
        }
        else {
          setImage("StaffaT/StaffaT_2.png");
        }
      } else {
        if (plateId < 6){
          setImage("StaffaT/StaffaT_5.png");
        }
        else {
          setImage("StaffaT/StaffaT_6.png");
        }
      }
    } else {
      setImage("StaffaT/StaffaT_5.png");
    }
  }

  function handleChangeH() {
    var plateId = parseInt(PlatePickerRef.current.getData());
    updateImage(plateId);
  }

  function handleChangeB(e) {
    const currentH = parseFloat(getValues("HookSecB"));
    ScrewPickerRef.current.setMaxL(currentH);
  }

  const onErrors = (errors) => console.error(errors);

  const onSubmit = (event) => {
    if (CreateReport === 0) {
      getRatio();
    } else if (CreateReport === 1) {
      getReport();
    }
  };

  const onChangeLoadDuration = (event) => {
    const value = event.target.value;
    SetLoadDuration(value);
    if (value === "0") {
      setKmodDisabled(false);
    } else {
      setKmodDisabled(true);
    }
  };

  const { t } = useTranslation();

  const onChangePlate = (event) => {
    const value = event;
    var iVal = parseInt(value);
    setPlateValue(iVal);
    if (iVal < 6) {
      ScrewPickerRef.current.setNodeId(6);
      ScrewPickerRef.current.setLinkDoc("SAF.pdf");
      ScrewPickerRef.current.setValue(300);
    } else {
      ScrewPickerRef.current.setNodeId(60);
      ScrewPickerRef.current.setLinkDoc("SPT.pdf");
      ScrewPickerRef.current.setValue(407);
    }
    updateImage(iVal);
    console.log(event);
  };

  const onChangeH = (event) => {
    var maxH = parseFloat(getValues("HookSecH"));
    if (isNaN(maxH)) {
      maxH = 200;
    }
    PlatePickerRef.current.setMaxL(maxH);
  };

  return (
    <form className="max-w-fit" onSubmit={handleSubmit(onSubmit, onErrors)}>
      <div className="flex flex-wrap -mx-2 mb-5">
        <div className="form-col1_3">
          <TransformWrapper>
            <TransformComponent>
              <img src={Image} alt="" />
            </TransformComponent>
          </TransformWrapper>
        </div>
        <div className="form-col1_3"></div>
        <div className="form-col1_3"></div>

        <div className="form-col1_6">
          <CodePicker ref={CodeRef}></CodePicker>
        </div>
        <ServiceClassPicker ref={ServiceClassRef} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-LoadDuration">
            {t("LoadDuration")}
          </label>
          <select className="form-select" id="grid-LoadDuration" name="grid-LoadDuration" onChange={onChangeLoadDuration} defaultValue={LoadDuration}>
            <option value="1">{t("Permanente")}</option>
            <option value="2">{t("Lunga")}</option>
            <option value="3">{t("Media")}</option>
            <option value="4">{t("Breve")}</option>
            <option value="5">{t("Istantanea")}</option>
            <option value="0">{t("Manual")}</option>
          </select>
        </div>
        {isKmodDisabled ? (
          <div />
        ) : (
          <div className="form-col1_6">
            <label className="form-label" for="grid-kmod">
              {t("Kmod")}
            </label>
            <input
              className="form-input"
              id="grid-kmod"
              type="number"
              step={0.01}
              placeholder={t("Kmod")}
              defaultValue={1}
              readOnly={isKmodDisabled}
              {...register("HookKmod", {
                required: t("Required"),
                min: {
                  value: 0.01,
                  message: t("Minimo") + " 0.01",
                },
                max: {
                  value: 10,
                  message: t("Massimo") + " 10",
                },
              })}
            ></input>
            <p className="form-error">{errors.HookKmod?.message}</p>
          </div>
        )}
        <div className="form-col1_6">
          <label className="form-label" for="grid-shear">
            {t("Shear")} V<sub>ed</sub> [kN]
          </label>
          <input
            className="form-input"
            id="grid-shear"
            type="number"
            step={0.01}
            defaultValue={1}
            placeholder="Ved [kN]"
            {...register("HookFvd", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p className="form-error">{errors.HookFvd?.message}</p>
        </div>
        {isKmodDisabled ? <div className="form-col1_6" /> : <div></div>}
        <div className="form-col1_6" />

        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-B">
            {t("MainBeamBase")}
          </label>
          <input
            className="form-input"
            id="grid-beam-B"
            type="number"
            step={1}
            placeholder="B [mm]"
            defaultValue={200}
            {...register("HookMainB", {
              required: t("Required"),
              min: {
                value: 10,
                message: t("Minimo") + " 10",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookMainB?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-H">
            {t("MainBeamHeight")}
          </label>
          <input
            className="form-input"
            id="grid-beam-H"
            type="number"
            step={1}
            placeholder="H [mm]"
            defaultValue={400}
            {...register("HookMainH", {
              required: t("Required"),
              min: {
                value: 10,
                message: t("Minimo") + " 10mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookMainH?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialRef} />
        <div className="form-col1_6"></div>
        <div className="form-col1_6"></div>
        <div className="form-col1_6"></div>

        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-B">
            {t("SecBeamBase")}
          </label>
          <input
            className="form-input"
            id="grid-beam-SecB"
            type="number"
            step={1}
            placeholder="B1 [mm]"
            defaultValue={100}
            {...register("HookSecB", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeB(e);
              },
              min: {
                value: 10,
                message: t("Minimo") + " 10",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookSecB?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-H">
            {t("SecBeamHeight")}
          </label>
          <input
            className="form-input"
            id="grid-beam-SecH"
            type="number"
            step={1}
            placeholder="H1 [mm]"
            defaultValue={200}
            {...register("HookSecH", {
              required: t("Required"),
              onChange: (e) => {
                onChangeH(e);
              },
              min: {
                value: 10,
                message: t("Minimo") + " 10mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookSecH?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialSecRef} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-Angle">
            {t("BetaAngle")}
          </label>
          <input
            className="form-input"
            id="grid-Angle"
            type="number"
            step={0.1}
            defaultValue={90}
            placeholder={t("BetaAngle")}
            {...register("HookAngle", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeH();
              },
              min: {
                value: 10,
                message: t("Minimo") + " 10°",
              },
              max: {
                value: 90,
                message: t("Massimo") + " 90°",
              },
            })}
          />
          <p className="form-error">{errors.HookAngle?.message}</p>
        </div>
        <div className="form-col1_6"></div>
        <div className="form-col1_6"></div>

        <PlatePicker ref={PlatePickerRef} startvalue={4} maxL={200} onCustomEvent={onChangePlate} linkdoc={"ETA130757.pdf"}></PlatePicker>
        <ScrewPicker ref={ScrewPickerRef} maxL={100} nodeTypeId={6} eta={true} minL={0} startvalue={300} linkdoc={"SAF.pdf"}/>
        <div className="form-col1_6">
          <label className="form-label" for="grid-Bsup">
            {t("Offset")} S <sub>B,sup</sub> [mm]
          </label>
          <input
            className="form-input"
            id="grid-Bsup"
            type="number"
            step={1}
            defaultValue={25}
            placeholder="SB,sup [mm]"
            {...register("HookBsup", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 2",
              },
              max: {
                value: 100,
                message: t("Massimo") + " 100",
              },
            })}
          />
          <p className="form-error">{errors.HookBsup?.message}</p>
        </div>
        <div className="form-col1_6" hidden={plateValue >= 6}>
          <label className="form-label" for="grid-Ny">
            {t("ConnectorNy")}
          </label>
          <input
            className="form-input"
            id="grid-Ny"
            type="number"
            step={1}
            defaultValue={2}
            placeholder="Ny"
            {...register("HookNy", {
              required: t("Required"),
              min: {
                value: 1,
                message: t("Minimo") + " 1",
              },
              max: {
                value: 100,
                message: t("Massimo") + " 100",
              },
            })}
          />
          <p className="form-error">{errors.HookNy?.message}</p>
        </div>
        <div className="form-col1_6" hidden={plateValue >= 6}>
          <label className="form-label" for="grid-StepY">
            {t("ConnectorStepy")}
          </label>
          <input
            className="form-input"
            id="grid-StepY"
            type="number"
            step={1}
            defaultValue={60}
            placeholder="Py [mm]"
            {...register("HookStepY", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0mm",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p className="form-error">{errors.HookStepY?.message}</p>
        </div>
        <div className="form-col1_6"></div>
        <div className="form-col1_6" hidden={plateValue < 6}></div>
        <div className="form-col1_6" hidden={plateValue < 6}></div>

        <div className="form-col1_5 py-5 px-3">
          <button name="btn1" className="bg-green-700 text-white font-bold py-2 px-3 rounded" onClick={() => SetCreateReport(0)}>
            {t("Check")}
          </button>
          <button
            name="btn2"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 ml-3 rounded align-right"
            onClick={() => SetCreateReport(1)}
          >
            {t("Report")}
          </button>
        </div>
        <div className="form-col1_2 py-5">
          {
            (validData) ? ((Ratio > 1.0) ? (<p className="form-result" hidden={!validData}>{Ratio}</p>): (<p className="form-result-ok" hidden={!validData}>{Ratio}</p>)) : (<div/>)
          }
          {
            (Ratio > 1.0 || !validData) ? (<p className="form-result">{resultMessages}</p>): (<p className="form-result-ok">{resultMessages}</p>)
          }
        </div>
      </div>
    </form>
  );
}
